import React from 'react'
import Footer from '../footer/Footer'
import { Outlet } from 'react-router-dom'
import Navbar from '../navbar/Navbar';

const Wrapper = () => {
  return (
    <div className="app-wrapper">
      <Navbar />
      <main id="main-content" className="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default Wrapper
